interface PricingCardProps {
  name: string;
  price: number | null;
  interval?: string;
  features: string[];
  isPopular?: boolean;
  isSelected?: boolean;
  onSelect?: () => void;
  buttonText?: string;
  trial?: boolean;
}

export default function PricingCard({
  name,
  price,
  interval = 'month',
  features,
  isPopular = false,
  isSelected = false,
  onSelect,
  buttonText,
  trial = false,
}: PricingCardProps) {
  const displayPrice = price === null ? 'Custom' : price === 0 ? 'Free' : `$${price}`;
  const defaultButtonText = price === null ? 'Contact Sales' : price === 0 ? 'Get Started' : 'Subscribe';

  return (
    <div
      className={`relative flex flex-col p-6 rounded-2xl border-2 transition-all ${
        isSelected
          ? 'border-purple-500 bg-purple-50 dark:bg-purple-900/20 shadow-lg scale-105'
          : isPopular
          ? 'border-purple-300 bg-white dark:bg-gray-800 shadow-md'
          : 'border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 hover:border-gray-300 dark:hover:border-gray-500'
      }`}
    >
      {isPopular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="bg-purple-600 text-white text-sm font-semibold px-4 py-1 rounded-full whitespace-nowrap">
            Most Popular
          </span>
        </div>
      )}

      <div className="text-center mb-6">
        <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">{name}</h3>
        <div className="flex items-baseline justify-center gap-1">
          <span className="text-4xl font-extrabold text-gray-900 dark:text-gray-100">{displayPrice}</span>
          {price !== null && price > 0 && (
            <span className="text-gray-500 dark:text-gray-400">/{interval}</span>
          )}
        </div>
        {trial && (
          <p className="mt-2 text-sm text-purple-600 dark:text-purple-400 font-medium">Free trial available</p>
        )}
      </div>

      <ul className="flex-1 space-y-3 mb-6">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <svg
              className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-gray-700 dark:text-gray-300">{feature}</span>
          </li>
        ))}
      </ul>

      <button
        onClick={onSelect}
        className={`w-full py-3 px-4 rounded-lg font-semibold transition-colors ${
          isSelected
            ? 'bg-purple-600 text-white hover:bg-purple-700'
            : isPopular
            ? 'bg-purple-600 text-white hover:bg-purple-700'
            : 'bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-gray-100 hover:bg-gray-200 dark:hover:bg-gray-600'
        }`}
      >
        {buttonText || defaultButtonText}
      </button>
    </div>
  );
}
